import { NavLink, NavLinkProps } from "@mantine/core";
import cx from "clsx";
import styles from "@scss/custom-components/nav.module.scss";

const CircleIcon = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="5" cy="5" r="4" fill="currentColor" />
  </svg>
);

interface CustomNavLinkProps extends NavLinkProps {
  icon?: React.ReactNode;
  onClick?: () => void;
}

export const CustomNavLink = ({
  className,
  icon,
  variant = "primary", // ← now using Mantine's variant prop
  rightSection,
  onClick,
  ...props
}: CustomNavLinkProps) => {
  const computedIcon = icon ?? (variant === "primary" ? <CircleIcon /> : null);

  return (
    <NavLink
      className={cx(className, styles[variant])} // your custom SCSS styling
      variant={variant}
      leftSection={computedIcon}
      onClick={onClick}
      rightSection={rightSection}
      {...props}
    />
  );
};
